import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const TypeOnView = ({ text, className = "", speed = 26 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView || n >= text.length) return;
    const t = setTimeout(() => setN((v) => v + 1), speed);
    return () => clearTimeout(t);
  }, [inView, n, text, speed]);

  return (
    <span ref={ref} className={className}>
      {text.slice(0, n)}
      {inView && n < text.length && (
        <span className="inline-block w-[3px] h-[0.8em] bg-brand ml-1 align-middle animate-pulse" />
      )}
      {!inView && <span className="opacity-0">{text}</span>}
    </span>
  );
};
